'use client';

import { c as _c } from "react/compiler-runtime";
import type { OnrampClient } from '@morfi/onramp-sdk';
import { useConnectedWallet } from '@morfi/onramp-sdk/react';
import { useLocale, useTranslations } from 'next-intl';
import { type ReactNode, useState } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { useFundingStage } from '../shared/funding-chrome';
import { FundingConnectedWalletFrame } from './funding-connected-wallet-frame';
import { FundingConnectedWalletStatus } from './funding-connected-wallet-status';
export function FundingConnectedWallet(t0) {
  const $ = _c(87);
  const {
    client,
    active,
    operationId,
    onBack,
    onAddressDeposit,
    onComplete
  } = t0;
  const t = useTranslations("onramp");
  const locale = useLocale();
  const [started, setStarted] = useState(operationId !== null && operationId !== undefined);
  const [showProvider, setShowProvider] = useState(false);
  let t1;
  if ($[0] !== operationId) {
    t1 = operationId === undefined ? {} : {
      operationId
    };
    $[0] = operationId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== active || $[3] !== locale || $[4] !== onComplete || $[5] !== t1) {
    t2 = {
      surface: "web",
      locale,
      active,
      onComplete,
      ...t1
    };
    $[2] = active;
    $[3] = locale;
    $[4] = onComplete;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    state,
    actions
  } = useConnectedWallet(client, t2);
  let t3;
  if ($[7] !== t) {
    t3 = t("connected_wallet_title");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useFundingStage(t3, false, onBack);
  let t4;
  if ($[9] !== actions) {
    t4 = () => {
      actions.submitted();
    };
    $[9] = actions;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const success = t4;
  let t5;
  if ($[11] !== actions) {
    t5 = () => actions.providerError();
    $[11] = actions;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const providerError = t5;
  if (!started && !state.operation) {
    let t6;
    if ($[13] !== t) {
      t6 = t("connected_wallet_intro");
      $[13] = t;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    let t7;
    if ($[15] !== t6) {
      t7 = <p className="text-body text-foreground-secondary">{t6}</p>;
      $[15] = t6;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    let t8;
    if ($[17] !== t) {
      t8 = t("connected_wallet_provider_title");
      $[17] = t;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    let t9;
    if ($[19] !== t8) {
      t9 = <h3 className="text-body font-medium">{t8}</h3>;
      $[19] = t8;
      $[20] = t9;
    } else {
      t9 = $[20];
    }
    let t10;
    if ($[21] !== t) {
      t10 = t("connected_wallet_provider_description");
      $[21] = t;
      $[22] = t10;
    } else {
      t10 = $[22];
    }
    let t11;
    if ($[23] !== t10) {
      t11 = <p className="mt-1 text-caption text-foreground-secondary">{t10}</p>;
      $[23] = t10;
      $[24] = t11;
    } else {
      t11 = $[24];
    }
    let t12;
    if ($[25] !== t11 || $[26] !== t9) {
      t12 = <div className="rounded-control bg-background-tertiary p-4">{t9}{t11}</div>;
      $[25] = t11;
      $[26] = t9;
      $[27] = t12;
    } else {
      t12 = $[27];
    }
    const t13 = state.busy;
    let t14;
    if ($[28] !== actions) {
      t14 = () => {
        setStarted(true);
        actions.start();
      };
      $[28] = actions;
      $[29] = t14;
    } else {
      t14 = $[29];
    }
    let t15;
    if ($[30] !== t) {
      t15 = t("connected_wallet_connect");
      $[30] = t;
      $[31] = t15;
    } else {
      t15 = $[31];
    }
    let t16;
    if ($[32] !== state.busy || $[33] !== t14 || $[34] !== t15) {
      t16 = <AnimatedButton className="h-11 w-full" disabled={t13} onClick={t14}>{t15}</AnimatedButton>;
      $[32] = state.busy;
      $[33] = t14;
      $[34] = t15;
      $[35] = t16;
    } else {
      t16 = $[35];
    }
    let t17;
    if ($[36] !== t) {
      t17 = t("connected_wallet_address_fallback");
      $[36] = t;
      $[37] = t17;
    } else {
      t17 = $[37];
    }
    let t18;
    if ($[38] !== onAddressDeposit || $[39] !== t17) {
      t18 = <AnimatedButton variant="secondary" className="h-11 w-full" onClick={onAddressDeposit}>{t17}</AnimatedButton>;
      $[38] = onAddressDeposit;
      $[39] = t17;
      $[40] = t18;
    } else {
      t18 = $[40];
    }
    let t19;
    if ($[41] !== t12 || $[42] !== t16 || $[43] !== t18 || $[44] !== t7) {
      t19 = <div className="flex flex-col gap-4">{t7}{t12}{t16}{t18}</div>;
      $[41] = t12;
      $[42] = t16;
      $[43] = t18;
      $[44] = t7;
      $[45] = t19;
    } else {
      t19 = $[45];
    }
    return t19;
  }
  if (!state.operation) {
    if (state.error) {
      let t6;
      if ($[46] !== t) {
        t6 = t("connected_wallet_unavailable");
        $[46] = t;
        $[47] = t6;
      } else {
        t6 = $[47];
      }
      let t7;
      if ($[48] !== t6) {
        t7 = <p className="text-body text-foreground-secondary">{t6}</p>;
        $[48] = t6;
        $[49] = t7;
      } else {
        t7 = $[49];
      }
      const t8 = state.busy;
      let t9;
      if ($[50] !== actions) {
        t9 = () => void actions.retry();
        $[50] = actions;
        $[51] = t9;
      } else {
        t9 = $[51];
      }
      let t10;
      if ($[52] !== t) {
        t10 = t("retry");
        $[52] = t;
        $[53] = t10;
      } else {
        t10 = $[53];
      }
      let t11;
      if ($[54] !== state.busy || $[55] !== t10 || $[56] !== t9) {
        t11 = <AnimatedButton variant="secondary" disabled={t8} onClick={t9}>{t10}</AnimatedButton>;
        $[54] = state.busy;
        $[55] = t10;
        $[56] = t9;
        $[57] = t11;
      } else {
        t11 = $[57];
      }
      let t12;
      if ($[58] !== t) {
        t12 = t("connected_wallet_address_fallback");
        $[58] = t;
        $[59] = t12;
      } else {
        t12 = $[59];
      }
      let t13;
      if ($[60] !== onAddressDeposit || $[61] !== t12) {
        t13 = <AnimatedButton variant="secondary" onClick={onAddressDeposit}>{t12}</AnimatedButton>;
        $[60] = onAddressDeposit;
        $[61] = t12;
        $[62] = t13;
      } else {
        t13 = $[62];
      }
      let t14;
      if ($[63] !== t11 || $[64] !== t13 || $[65] !== t7) {
        t14 = <div role="alert" className="flex flex-col gap-3">{t7}{t11}{t13}</div>;
        $[63] = t11;
        $[64] = t13;
        $[65] = t7;
        $[66] = t14;
      } else {
        t14 = $[66];
      }
      return t14;
    }
    let t6;
    if ($[67] !== t) {
      t6 = t("connected_wallet_loading");
      $[67] = t;
      $[68] = t6;
    } else {
      t6 = $[68];
    }
    let t7;
    if ($[69] !== t6) {
      t7 = <p className="text-body text-foreground-secondary">{t6}</p>;
      $[69] = t6;
      $[70] = t7;
    } else {
      t7 = $[70];
    }
    return t7;
  }
  if (!state.operation.widget || state.operation.state !== "wallet_widget" && !showProvider) {
    let t6;
    if ($[71] !== state.operation.state || $[72] !== state.operation.widget) {
      t6 = state.operation.state === "below_minimum" && state.operation.widget ? {
        onTopUp: () => setShowProvider(true)
      } : {};
      $[71] = state.operation.state;
      $[72] = state.operation.widget;
      $[73] = t6;
    } else {
      t6 = $[73];
    }
    let t7;
    if ($[74] !== state.operation || $[75] !== t6) {
      t7 = <FundingConnectedWalletStatus operation={state.operation} {...t6} />;
      $[74] = state.operation;
      $[75] = t6;
      $[76] = t7;
    } else {
      t7 = $[76];
    }
    return t7;
  }
  let t6;
  if ($[77] !== providerError || $[78] !== state.operation.widget || $[79] !== success) {
    t6 = <FundingConnectedWalletFrame widget={state.operation.widget} onReady={_temp} onSuccess={success} onError={providerError} />;
    $[77] = providerError;
    $[78] = state.operation.widget;
    $[79] = success;
    $[80] = t6;
  } else {
    t6 = $[80];
  }
  let t7;
  if ($[81] !== state.error || $[82] !== t) {
    t7 = state.error === "provider_error" ? <p role="alert" className="p-3 text-caption text-foreground-secondary">{t("connected_wallet_provider_error")}</p> : null;
    $[81] = state.error;
    $[82] = t;
    $[83] = t7;
  } else {
    t7 = $[83];
  }
  let t8;
  if ($[84] !== t6 || $[85] !== t7) {
    t8 = <div className="overflow-hidden rounded-control bg-background-tertiary">{t6}{t7}</div>;
    $[84] = t6;
    $[85] = t7;
    $[86] = t8;
  } else {
    t8 = $[86];
  }
  return t8;
}
function _temp() {}